/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Planendson2Inputs */

const en_planendson2 = /** @type {(inputs: Planendson2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ends on ${i?.date}`)
};

const de_planendson2 = /** @type {(inputs: Planendson2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Endet am ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Ends on {date}" |
*
* @param {Planendson2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const planendson2 = /** @type {((inputs: Planendson2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planendson2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_planendson2(inputs)
	return de_planendson2(inputs)
});
export { planendson2 as "planEndsOn" }